module.exports = __webpack_public_path__ + "static/img/pop_up_bg.5646b73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/win_lose/pop_up_bg.png
// module id = WniJ
// module chunks = 1